import React from 'react';
import { theme } from 'lib/style';
import styled from 'styled-components/macro';
import {
  CommonTypography,
  ParagraphSmall,
} from 'lib/components/styles/typography';
import { addThousandCommaSeparator } from 'lib/utils/functions';
import { LoadingIndicator } from 'lib/components';

const Stats = styled.div`
  align-items: center;
  border-radius: 4px;
  padding: 24px;
  width: 100%;
  background: ${theme.palette.white};
  border: 1px solid ${theme.palette.gray};
  box-shadow: 0px 4px 12px ${theme.palette.boxShadow};
  box-sizing: border-box;
  flex: 1;
  max-height: 154px;
  position: relative;
`;

const Count = styled(CommonTypography).attrs({ as: 'p' })`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
  color: ${theme.palette.blue100};
  margin: 8px 0px 16px;
`;

type Props = {
  count: number;
  type?: 'number' | 'percentage';
  text: string;
  isLoading: boolean;
};

export const UsageStatsCard = ({
  count,
  text,
  isLoading,
  type = 'number',
}: Props) => {
  return (
    <Stats>
      {isLoading ? (
        <LoadingIndicator isLoading height={100} />
      ) : (
        <>
          <ParagraphSmall color={theme.palette.gray100}>{text}</ParagraphSmall>
          <Count>
            {type === 'percentage'
              ? `${count.toFixed(2)}%`
              : addThousandCommaSeparator(count)}
          </Count>
        </>
      )}
    </Stats>
  );
};
